import { z } from 'zod';
export const RateKindSchema = z.enum([
    'HORA',
    'SERVICIO',
    'IGUALA_MENSUAL',
    'HITO',
    'SUSCRIPCION_INFRA',
]);
export const RateKindLabel = {
    HORA: 'Hora',
    SERVICIO: 'Servicio',
    IGUALA_MENSUAL: 'Iguala mensual',
    HITO: 'Hito',
    SUSCRIPCION_INFRA: 'Suscripción / infra',
};
export const RateKindShort = {
    HORA: '€/h',
    SERVICIO: '€/servicio',
    IGUALA_MENSUAL: '€/mes',
    HITO: '€/hito',
    SUSCRIPCION_INFRA: '€/mes',
};
// Reusamos el ServiceLine declarado en opportunities.ts.
import { ServiceLineSchema } from './opportunities';
export const RateDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    kind: RateKindSchema,
    amountCents: z.number().int(),
    /** Coste interno por unidad (mismo criterio que amountCents). Campo interno (margen). */
    costCents: z.number().int().min(0).nullable().optional(),
    /** IVA como fracción (0.21 = 21%). */
    vatRate: z.number(),
    serviceLine: ServiceLineSchema.nullable(),
    description: z.string().nullable(),
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const RateListResponseSchema = z.object({
    items: z.array(RateDtoSchema),
});
export const CreateRateInputSchema = z.object({
    name: z.string().min(1, 'Nombre obligatorio').max(120),
    kind: RateKindSchema,
    amountCents: z.number().int().min(0, 'No puede ser negativo'),
    /** Coste interno por unidad (mismo criterio que amountCents). Campo interno (margen). */
    costCents: z.number().int().min(0).nullable().optional(),
    vatRate: z.number().min(0).max(1, 'IVA en fracción (0–1)'),
    serviceLine: ServiceLineSchema.nullable().optional(),
    description: z.string().max(1000).nullable().optional(),
    isActive: z.boolean().optional(),
});
export const UpdateRateInputSchema = CreateRateInputSchema.partial();
// ===== Asignaciones cliente → tarifa =====
export const ClientRateDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    rateId: z.string(),
    /** Si null, se usa Rate.amountCents al insertar línea. */
    overrideAmountCents: z.number().int().nullable(),
    notes: z.string().nullable(),
    rate: RateDtoSchema,
});
export const ClientRateListResponseSchema = z.object({
    items: z.array(ClientRateDtoSchema),
});
export const CreateClientRateInputSchema = z.object({
    rateId: z.string().min(1),
    overrideAmountCents: z.number().int().min(0).nullable().optional(),
    notes: z.string().max(500).nullable().optional(),
});
export const UpdateClientRateInputSchema = z.object({
    overrideAmountCents: z.number().int().min(0).nullable().optional(),
    notes: z.string().max(500).nullable().optional(),
});
// ===== Picker: tarifas aplicables a un cliente/área =====
// Devuelve catálogo + las asignadas marcadas + applied amount (override o base).
export const RatePickerItemSchema = z.object({
    rateId: z.string(),
    name: z.string(),
    kind: RateKindSchema,
    serviceLine: ServiceLineSchema.nullable(),
    baseAmountCents: z.number().int(),
    /** Importe que se aplicará (override del cliente si existe; si no, base). */
    appliedAmountCents: z.number().int(),
    vatRate: z.number(),
    description: z.string().nullable(),
    /** True si proviene de una asignación ClientRate del cliente solicitado. */
    isAssignedToClient: z.boolean(),
});
export const RatePickerResponseSchema = z.object({
    items: z.array(RatePickerItemSchema),
});
//# sourceMappingURL=rates.js.map